import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { StatusDisplay } from '@verantos-dev/shared-components';

export const CohortStatus = ({ cohortStatus = '' }: { cohortStatus?: string }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mr: theme.spacing(5),
      }}
    >
      {cohortStatus && <StatusDisplay status={`cohortstatus${cohortStatus.toLowerCase()}`} />}
    </Box>
  );
};
